import { render } from "./ArticleTemplateSelect.vue?vue&type=template&id=450450b5"
import script from "./ArticleTemplateSelect.vue?vue&type=script&lang=js"
export * from "./ArticleTemplateSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__